// App.create's environment map ({ appName: { alias: value } }) from the dbApps payload's per-app environment.
export function environmentByApp(catalog) {
  return Object.fromEntries(Object.entries(catalog ?? {}).map(([appName, entry]) => [appName, entry?.environment ?? {}]));
}
